import { axios } from './axios';
import { endpoints } from '../constants';
import type { SUBSCRIPTION_BODY } from '../hooks/api/subscription';

export default {
  async create(body: SUBSCRIPTION_BODY, params: any) {
    const { subscriptionUrl } = endpoints();

    try {
      const { data } = await axios.post(`${subscriptionUrl}`, body, { params });
      return data;
    } catch (error) {
      throw new Error('Failed to update subscription');
    }
  },
};
